import _ from "lodash";
import { Types } from "./xeroActions";



const xeroReducers = (state, action) => {
    switch (action.type) {
        case Types.XERO_SEND_DATA: {

            let newState = _.cloneDeep(state);

            const sending = newState.integration?.accounting?.xero?.sendingPayroll

            let sendingPayroll = [ ...(Array.isArray(sending) ? sending : []) ]

            if (action.status) {
                sendingPayroll.push(action.periodId)
            } else {
                sendingPayroll = sendingPayroll?.filter(item => item != action.periodId)
            }

            newState.integration.accounting = {
                ...newState.integration?.accounting,
                xero: {
                    ...newState.integration?.accounting?.xero,
                    sendingPayroll
                }
            }

            return newState;
        }
        case Types.XERO_SAVING_DATA: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting = {
                ...newState.integration?.accounting,
                xero: {
                    ...newState.integration?.accounting?.xero,
                    savingData: action.status
                }
            }

            return newState;
        }
        case Types.XERO_UPDATE_CONTACTS: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting = {
                ...newState.integration?.accounting,
                xero: {
                    ...newState.integration?.accounting?.xero,
                    contacts: action.contacts
                }
            }

            return newState;
        }
        case Types.XERO_UPDATE_SETTINGS: {

            let newState = _.cloneDeep(state);

            newState.integration.accounting = {
                ...newState.integration?.accounting,
                xero: {
                    name: 'Xero',
                    ...newState.integration?.accounting?.xero,
                    ...action.payload
                }
            }

            return newState;
        }

        default:
            return state;
    }
};

export default xeroReducers;